import { ReactNode } from "react";

import FormLabel from "react-bootstrap/FormLabel";
import FormControl, { FormControlProps } from "react-bootstrap/FormControl";

import { SkeletonWrapper } from "@/components/SkeletonWrapper";

import "./styles.scss";

type Props = FormControlProps & {
	notEditable?: boolean;
	isEditing: boolean;
	skeleton: boolean;
	children?: ReactNode;
	label: string;
	data?: string;
};

export function ListOrFormControlUpdate({
	notEditable = false,
	isEditing,
	skeleton,
	children,
	label,
	data,
	...rest
}: Props) {
	function Label() {
		return (
			<FormLabel htmlFor={rest.id} className="fs-7 fw-bold white-space-no-wrap me-1">
				{label}
			</FormLabel>
		);
	}

	function checkChildrenAndData() {
		if (data) {
			return <span className="fs-7">{data}</span>;
		}

		if (children) {
			return children;
		}

		return <FormControl className="fs-7 px-3 py-2" {...rest} />;
	}

	return (
		<div className="w-100">
			{skeleton ? (
				<SkeletonWrapper height={23} />
			) : isEditing ? (
				<div className="input-container">
					<Label />

					{notEditable ? <span className="fs-7">{data}</span> : checkChildrenAndData()}
				</div>
			) : (
				<div>
					<Label />

					{data && <span className="fs-7">{data}</span>}
				</div>
			)}
		</div>
	);
}
